export default __webpack_public_path__ + "static/media/obutsudan-top.7cc8eb30.jpg";